import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { AccordionPanel } from 'reaxl';
import { FilterCheckboxes } from 'reaxl-filters';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterPlaceholder from './FilterPlaceholder';

function FeaturesFilter({
    onOptionChange = () => { },
    onOptionsClear = () => { },
    handleShowExpansion = () => { },
}) {

    const featuresOptions = useSelector(srpFiltersDuck.selectors.getFeaturesOptions);
    const featuresValues = useSelector(srpFiltersDuck.selectors.getFeaturesValue);

    const filtersErrors = useSelector(srpFiltersDuck.selectors.getFiltersErrors);

    const filterName = 'featureCode';
    const isExpanded = useSelector((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName));
    const showFilter = isExpanded && Object.keys(featuresOptions).length !== 0;

    const title = getFilterTitle('Features', featuresValues);
    const filterValues = {
        featureCode: featuresValues,
    };

    // expand the panel if active options inside of it
    useEffect(() => {
        if (featuresValues.length) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [featuresValues.length]);

    const featureFilters = (
        <FilterCheckboxes
            filter={featuresOptions}
            values={filterValues}
            onOptionChange={onOptionChange}
            onOptionsClear={onOptionsClear}
            errors={filtersErrors}
            withAccordion={false}
        />
    );
    return (
        <AccordionPanel
            contentPadding={5}
            eventKey={filterName}
            data-cmp="FeaturesFilter"
            title={title}
        >
            {!showFilter && <FilterPlaceholder uniqueKey={filterName} />}
            {showFilter && featureFilters}
        </AccordionPanel>
    );
}

export default FeaturesFilter;
